module.exports = __webpack_public_path__ + "static/img/chill_out_corner.90e2fe93.png";